import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {Grandmaster} from "lo-bahamut";
import { SharedModule } from '../_shared/shared.module';
import { CustomCarouselModule } from '../_shared/custom-carousel/custom-carousel.module';
import { ComingSoonModule } from '../coming-soon/coming-soon.module';
import {SearchStartV2Component} from "./search-start-v2.component";

@NgModule({
    declarations: [SearchStartV2Component],
    imports: [
        ComingSoonModule,
        CommonModule,
        SharedModule,
        CustomCarouselModule,
        Grandmaster
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        SearchStartV2Component
    ]
})
export class SearchStartV2Module {}
